export default {
  'underconstruction': {
    en: 'Under construction',
    es: 'En construcción',
    pt: 'Em construção',
  },
  'THE NUMBERS': {
    en: 'NUMBERS',
    es: 'NÚMEROS',
    pt: 'NÚMEROS',
  },
  'MUSICIANS': {
    en: 'MUSICIANS',
    es: 'MÚSICOS',
    pt: 'MÚSICOS',
  },
    'TIME': {
    en: 'MINUTES',
    es: 'MINUTOS',
    pt: 'MINUTOS',
  },
    'LISTENERS': {
    en: 'LISTENERS',
    es: 'OYENTES',
    pt: 'OUVINTES',
  },
      'CALLS': {
    en: 'CONCERTS',
    es: 'LLAMADAS',
    pt: 'CONCERTOS',
  },
  "cada historia cuenta": {
      en: "every moment counts",
      es: "cada historia cuenta",
      pt: "toda história conta"
  },
  'NUMBERS': {
    en: 'NUMBERS',
    es: 'NÚMEROS',
    pt: 'NÚMEROS',
},
  'MAPS': {
    en: 'MAPS',
    es: 'MAPA',
    pt: 'MAPA',
},
  'PRESS': {
    en: 'PRESS',
    es: 'PRENSA',
    pt: 'IMPRENSA',
},
  'REPORTS': {
    en: 'REPORTS',
    es: 'REPORTES',
    pt: 'REPORTES',
  },
}
